
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formula1-racing/circuits",
      function () {
        return require("private-next-pages/formula1-racing/circuits/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/formula1-racing/circuits"])
      });
    }
  